function getEvents(pageId, duration, xValue) {
  if (
    process.env.STORYBOOK_DISABLE_ANIMATIONS === "1" ||
    process.env.STORYBOOK_DISABLE_ANIMATIONS
  ) {
    return {};
  }
  return {
    events: {
      e: {
        id: "e",
        name: "",
        animationType: "custom",
        eventTypeId: "SCROLL_INTO_VIEW",
        action: {
          id: "",
          actionTypeId: "GENERAL_START_ACTION",
          config: {
            delay: 0,
            easing: "",
            duration: 0,
            actionListId: "a",
            affectedElements: {},
            playInReverse: false,
            autoStopEventId: "e-534",
          },
        },
        mediaQueries: ["main", "medium", "small", "tiny"],
        target: {
          id: `${pageId}|659f300c-86f0-4612-17ac-4a28fca7b1b4`,
          appliesTo: "ELEMENT",
          styleBlockIds: [],
        },
        targets: [
          {
            id: `${pageId}|659f300c-86f0-4612-17ac-4a28fca7b1b4`,
            appliesTo: "ELEMENT",
            styleBlockIds: [],
          },
        ],
        config: {
          loop: true,
          playInReverse: false,
          scrollOffsetValue: 0,
          scrollOffsetUnit: "%",
          delay: null,
          direction: null,
          effectIn: null,
        },
        createdOn: 1634186533010,
      },
    },
    actionLists: {
      a: {
        id: "a",
        title: "Testimonial 21 [Loop]",
        actionItemGroups: [
          {
            actionItems: [
              {
                id: "a-n",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "",
                  duration,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".testimonial21_component",
                    selectorGuids: ["796da0d5-eee6-b9ba-6d60-010ba3ab433f"],
                  },
                  xValue,
                  xUnit: "rem",
                  yUnit: "PX",
                  zUnit: "PX",
                },
              },
            ],
          },
          {
            actionItems: [
              {
                id: "a-n-2",
                actionTypeId: "TRANSFORM_MOVE",
                config: {
                  delay: 0,
                  easing: "",
                  duration: 0,
                  target: {
                    useEventTarget: "CHILDREN",
                    selector: ".testimonial21_component",
                    selectorGuids: ["796da0d5-eee6-b9ba-6d60-010ba3ab433f"],
                  },
                  xValue: 0,
                  xUnit: "rem",
                  yUnit: "PX",
                  zUnit: "PX",
                },
              },
            ],
          },
        ],
        useFirstGroupAsInitialState: false,
        createdOn: 1634186546050,
      },
    },
    site: {
      mediaQueries: [
        { key: "main", min: 992, max: 10000 },
        {
          key: "medium",
          min: 768,
          max: 991,
        },
        { key: "small", min: 480, max: 767 },
        { key: "tiny", min: 0, max: 479 },
      ],
    },
  };
}

// eslint-disable-next-line import/no-default-export
export default getEvents;
